import { frontendURL } from '../../../helper/URLHelper';
import FlowBuilderIndex from './Index.vue';
import FlowBuilderEditor from '../settings/flowBuilder/Index.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/flow-builder'),
    name: 'flow_builder_index',
    component: FlowBuilderIndex,
    meta: {
      permissions: ['administrator'],
    },
  },
  {
    path: frontendURL('accounts/:accountId/flow-builder/new'),
    name: 'flow_builder_new',
    component: FlowBuilderEditor,
    meta: {
      permissions: ['administrator'],
    },
  },
  {
    path: frontendURL('accounts/:accountId/flow-builder/:id/edit'),
    name: 'flow_builder_edit',
    component: FlowBuilderEditor,
    meta: {
      permissions: ['administrator'],
    },
  },
];
